export default function Facebook({ className }: { className ?: string}) {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="20"
    viewBox="0 0 12 20"
    fill="none"
    className={className}
  >
    <path
      d="M8.51563 4.31348C8.32639 4.31348 8.0966 4.40134 7.82627 4.57706C7.55593 4.75278 7.42076 5.01635 7.42076 5.36779V6.42211H10.6243V10.6394H7.42076V19.155H3.2035V10.6394H0V6.42211H3.2035V4.31348C3.2035 3.7728 3.32515 3.24564 3.56845 2.732C3.81176 2.21836 4.15644 1.76555 4.60249 1.37356C5.04855 0.981569 5.56895 0.663923 6.16369 0.420619C6.75843 0.177316 7.40724 0.0556641 8.11012 0.0556641H11.6786V4.31348H8.51563Z"
      fill="black"
    />
  </svg>;
}
